/**
 * TTP Agent SDK - Main Entry Point
 * 
 * A comprehensive SDK for voice and text interaction with AI agents.
 * Provides real-time audio recording, WebSocket communication, and audio playback.
 * 
 * Features:
 * - 🎤 Real-time Audio Recording with AudioWorklet
 * - 💬 Text Chat Support
 * - 🔄 WebSocket Communication with authentication
 * - 🔊 Audio Playback with queue management
 * - ⚛️ React Components
 * - 🌐 Vanilla JavaScript Components
 * - 🎯 Event-driven architecture
 * - 🔒 Multiple authentication methods
 */

// ✅ SDK Loaded - Sandbox test build (2026-01-20)
console.log('[TTP SDK] ✅ Sandbox Deployment Test - v2.33.9-SANDBOX (with NEW conversation panel: collapsed/expanded states & compact design)');

// Core SDK
import VoiceSDK_v2 from './v2/VoiceSDK.js';
import TextChatSDK from './core/TextChatSDK.js';
import WebSocketManager from './core/WebSocketManager.js';
import AudioRecorder from './core/AudioRecorder.js';
import AudioPlayer from './core/AudioPlayer.js';
import EventEmitter from './core/EventEmitter.js';

// React components
import VoiceButton from './react/VoiceButton.jsx';

// Vanilla JavaScript components
import VanillaVoiceButton from './vanilla/VoiceButton.js';

// TTPChatWidget and AgentSDK (AgentSDK is used by VoiceInterface, which TTPChatWidget uses)
import { AgentSDK } from './legacy/AgentSDK.js';
import { TTPChatWidget } from './legacy/TextChatWidget.js';

// Microphone Permission Utilities
import * as MicPermissionUtils from './shared/MicPermissionUtils.js';
import * as MicPermissionModals from './shared/MicPermissionModals.js';

// Version
export const VERSION = '2.18.0';

// Named exports
export {
  VoiceSDK_v2,
  TextChatSDK,
  WebSocketManager,
  AudioRecorder,
  AudioPlayer,
  EventEmitter,
  VoiceButton,
  VanillaVoiceButton,
  AgentSDK,
  TTPChatWidget,
  MicPermissionUtils,
  MicPermissionModals
};

// Default export for convenience
export default {
  VoiceSDK_v2,
  TextChatSDK,
  WebSocketManager,
  AudioRecorder,
  AudioPlayer,
  EventEmitter,
  VoiceButton,
  VanillaVoiceButton,
  AgentSDK,
  TTPChatWidget,
  VERSION
};
